module.exports = __webpack_public_path__ + "static/img/方太F3 纤薄顶吸烟机灶具套装.885f2755.png";